export default "//0f174046-a3c4-46d7-88af-9cfef9e6bcb2.selcdn.net/webpack/production/39783d403804853503bf7c6e4c71bb1c.svg";